export const styles = {
  container: "flex items-center justify-around mb-8",
  inner: "flex flex-col flex-1",
  row: "flex items-center justify-between mb-0",
  left: "flex items-center space-x-2 text-xs font-bold text-black lg:text-base",
  iconWrapper: "mr-3",
  right: "flex items-center justify-between space-x-4",
  amount: "text-xs font-bold text-black lg:text-base",
  currency: "text-xs font-bold text-black lg:text-base",
};
